import { useEffect, useState } from 'react';

interface CountUpProps {
  end: number | null | undefined;
  duration?: number;
  decimals?: number;
  suffix?: string;
}

export const CountUp: React.FC<CountUpProps> = ({ end, duration = 2000, decimals = 0, suffix = '' }) => {
  const [count, setCount] = useState(0);

  // Handle null/undefined end value
  const targetValue = end ?? 0;

  useEffect(() => {
    let startTime: number;
    let animationFrame: number;

    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = targetValue * easeOutQuart;

      setCount(currentCount);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(targetValue);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [targetValue, duration]);

  const formattedValue = decimals > 0
    ? count.toFixed(decimals)
    : Math.floor(count).toLocaleString();

  return <>{formattedValue}{suffix}</>;
};

